<template>
  <div class="tabs">
    <button class="tabs__item"
            v-for="(item, index) in tabs"
            :class="{'tabs__item--active': item.active}"
            @click="$emit('changeTab', index)"
    >
      <span>{{item.title}}</span>
    </button>
  </div>
</template>

<script>
  export default {
    name: "Tabs",
    props: {
      tabs: {
        type: Array
      }
    }
  }
</script>

<style lang="scss">
  @import "../style/var";

  .tabs {
    position: absolute;
    bottom: 100%;
    left: 0;
    display: flex;
    align-items: flex-end;
    &--big {
      .tabs__item {
        max-width: 200px;
        min-width: 200px;
      }
    }
    &__item {
      display: flex;
      align-items: center;
      justify-content: center;
      max-width: 107px;
      min-width: 107px;
      height: 32px;
      font-size: 15px;
      background-color: #DCDCDC;
      border: none;
      cursor: pointer;
      &--active {
        height: 39px;
        padding-top: 7px;
        background-color: $gray;
      }
    }
  }
</style>